module.exports = __webpack_public_path__ + "public/images/tg_icon_ft.43f36f2fbd1fbaf1c91e55636144c16e.svg";